import { Icon } from "@iconify/react";
import React from "react";

export default function CustomButton({
  txt,
  bgcolor = "#B36427",
  color = "white",
  onClick = () => {},
  radius = 10,
  padding = 10,
  classAdditional = " font_Kanit",
  leftIconName,
  rightIconName,
}) {
  return (
    <div
      onClick={() => {
        if (onClick != null) {
          onClick();
        }
      }}
      className={
        "hover:opacity-80 active:opacity-50  cursor-pointer flex flex-row items-center gap-3  " +
        classAdditional
      }
      style={{
        color: color,
        backgroundColor: bgcolor,
        borderRadius: radius,
        padding: padding,
      }}
    >
      {leftIconName ? <Icon icon={leftIconName}  /> : null}
      <span className="flex-1">{txt}</span>
      {rightIconName ? <Icon icon={rightIconName}  /> : null}

    </div>
  );
}
